import { Box, Divider, ListItem, ListItemText } from "@material-ui/core";
import { sanitizeTestId } from "@roc/feature-utils";
import { TestDataAttribute } from "@roc/ui";

export const listItem = (label, value, customTestId = null) => {
  const testId = sanitizeTestId(customTestId || label);
  return (
    <ListItem disableGutters>
      <ListItemText>
        <Box display="flex">
          <Box flexGrow={1} display="flex">{label}</Box>
          <TestDataAttribute id={testId}>
            <Box>{value}</Box>
          </TestDataAttribute>
        </Box>
      </ListItemText>
    </ListItem>
  );
};

export const divider = <Divider variant="fullWidth" component="li" />;